import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-peisongshijian",
  "use": "icon-peisongshijian-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-peisongshijian\"><path d=\"M512 1014.4A502.4 502.4 0 1 1 1014.4 512 503.04 503.04 0 0 1 512 1014.4z m0-921.6A419.2 419.2 0 1 0 931.2 512 419.712 419.712 0 0 0 512 92.8z\" fill=\"#e6e6e6\" p-id=\"27029\" /><path d=\"M603.648 731.392A41.856 41.856 0 0 1 571.392 716.8l-104.576-128a42.24 42.24 0 0 1-9.472-25.6V280.192a41.6 41.6 0 0 1 83.2 0V547.84l95.104 115.2a41.472 41.472 0 0 1-32 67.968z\" fill=\"#e6e6e6\" p-id=\"27030\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/peisongshijian.svg
// module id = ByUf
// module chunks = 51